import { gql } from 'Utils/apolloClient'

const stripeTerminalTokenCreateMutation = gql`
  mutation stripeTerminalTokenCreate {
    stripeTerminalTokenCreate(input: {}) {
      error
      token
    }
  }`

export default stripeTerminalTokenCreateMutation
